import { Sparkles, X } from 'lucide-react';
import '../accessoriesStyles/hero.css';
import { ImageWithFallback } from './figma/ImageWithFallback.jsx';

export function Hero({ onMenuItemClick, onClearFilters, filters }) {
  // Mobile accessory images for the hero
  const accessoryImages = [
    'https://images.unsplash.com/photo-1760712491539-431d07f3279a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3aXJlbGVzcyUyMGVhcmJ1ZHMlMjBwaG9uZSUyMGFjY2Vzc29yaWVzfGVufDF8fHx8MTc3MDExMTAwMXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
    'https://images.unsplash.com/photo-1764116679125-b1db58fb37f1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwaG9uZSUyMGNhc2UlMjBwcm90ZWN0aW9uJTIwbW9iaWxlfGVufDF8fHx8MTc3MDExMTAwMXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
    'https://images.unsplash.com/photo-1760708825913-65a50b3dc39b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwb3dlciUyMGJhbmslMjBjaGFyZ2VyJTIwZ2FkZ2V0fGVufDF8fHx8MTc3MDExMTAwMnww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
  ];

  const menuItems = [
    { label: 'iPad Keyboard', brand: 'Apple', category: 'Protection', type: 'ipad-keyboard' },
    { label: 'Marshall Speaker', brand: 'Marshall', category: 'Audio', type: 'marshall-speaker' },
    { label: 'Phone Cases', brand: 'Muvtech', category: 'Protection', type: 'phone-cases' },
  ];

  // Check if any menu filter is currently active
  const isMenuFilterActive = filters?.categories.length > 0 && filters?.brands.length > 0;

  const handleMenuClick = (item) => {
    if (onMenuItemClick) {
      onMenuItemClick(item);
    }
  };

  const handleClearClick = () => {
    if (onClearFilters) {
      onClearFilters();
    }
  };

  return (
    <div className="hero">
      {/* Floating Accessory Images */}
      <div className="hero-floating-images">
        {accessoryImages.map((img, index) => (
          <div
            key={index}
            className="hero-floating-image"
            style={{
              left: `${20 + index * 30}%`,
              top: `${10 + index * 20}%`,
              transform: `rotate(${-15 + index * 15}deg)`,
            }}
          >
            <ImageWithFallback
              src={img}
              alt={`Accessory ${index + 1}`}
            />
          </div>
        ))}
      </div>

      <div className="hero-grid-overlay" />
      
      <div className="hero-content">
        <div className="hero-badge">
          <Sparkles className="hero-badge-icon" />
          <span className="hero-badge-text">New Collection</span>
        </div>
        
        <h1 className="hero-title">
          Accessories Revolution
        </h1>
        <p className="hero-subtitle">
          Premium Gear for Every Device
        </p>

        {/* Menu Bar */}
        <div className="hero-menu-bar">
          {menuItems.map((item) => (
            <button
              key={item.type}
              className="hero-menu-item"
              onClick={() => handleMenuClick(item)}
            >
              {item.label}
            </button>
          ))}
          {isMenuFilterActive && (
            <button
              className="hero-clear-icon-button"
              onClick={handleClearClick}
              title="Clear filter"
            >
              <X size={16} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
